import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6MzEsImFnZW50U2x1ZyI6ImFzc2lzdGFudC1pbnNpZGUtc2FsZXMiLCJ0ZW5hbnRTbHVnIjoiaW5zaWRlLXNpc3RlbWFzIiwiYXNzaXN0YW50TmFtZSI6IkFnZW50ZSBjb21lcmNpYWwgZGEgSW5zaWRlIFNpc3RlbWFzIiwibWV0YWRhdGEiOnsiY2hhbm5lbERlZmF1bHQiOiJ3ZWJfZW1iZWQifX0.1f7955ce38d5ede0a0aeea9c23d4394597eeaeb2302eda4f6e22a074bc2e2322',
  agentSlug: 'assistant-inside-sales',
  tenantSlug: 'inside-sistemas',
  organizationId: '31',
  assistantName: 'Agente comercial da Inside Sistemas',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'inside-sales-preview',
}

const InsideSalesPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_INSIDE_SALES_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_INSIDE_SALES_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const resolvedTenant =
    queryParams.get('tenantSlug') ||
    env.REACT_APP_INSIDE_SALES_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  const tenantSlug = resolvedTenant.toString().trim().toLowerCase()

  const orgId =
    queryParams.get('organizationId') ||
    env.REACT_APP_INSIDE_SALES_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_INSIDE_SALES_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) {
      params.set('token', embedToken)
    }
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', orgId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'inside-sales-preview')
    params.set('meta.partner', 'inside-sistemas')

    const baseUrl = env.REACT_APP_INSIDE_SALES_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    orgId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex flex-col w-full min-h-screen overflow-hidden bg-[#050913] text-white">
      <Seo
        title="InsidePrime Sales Preview | Lean it 101"
        description="Private preview route for Inside Sistemas sales assistant."
        path="/inside-sales"
        noindex
      />
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#070c1b] via-[#050913] to-[#050913]" />
        <div
          className="absolute -top-24 left-1/2 -translate-x-1/2 w-[620px] h-[620px] rounded-full opacity-30"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(25,162,207,0.5) 0%, rgba(25,162,207,0) 60%)',
            filter: 'blur(48px)',
          }}
        />
        <div
          className="absolute bottom-[-260px] right-[-120px] w-[560px] h-[560px] rounded-full opacity-20"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(248,129,22,0.4) 0%, rgba(248,129,22,0) 65%)',
            filter: 'blur(40px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.07) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.07) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
      </div>

      <div className="w-full max-w-5xl mx-auto px-4 py-12 md:py-16 space-y-8">
        <header className="text-center space-y-4">
          <p className="text-xs uppercase tracking-[0.4em] text-slate-400">
            Inside Sistemas
          </p>
          <h1 className="text-3xl md:text-4xl font-semibold">
            InsidePrime – Agente Comercial
          </h1>
          <p className="text-base md:text-lg text-slate-200">
            Ambiente de teste para o agente comercial da Inside. Use este link
            para validar tom de voz, perguntas e fluxo de diagnóstico antes de
            divulgar para prospects reais.
          </p>
        </header>

        <div className="w-full bg-slate-900/50 border border-slate-800 rounded-2xl shadow-2xl">
          <div className="relative w-full h-[460px] md:h-[520px]">
            <iframe
              title="InsidePrime – agente comercial"
              src={iframeSrc}
              allow="clipboard-read; clipboard-write"
              className="absolute inset-0 w-full h-full rounded-2xl"
              style={{ background: 'transparent' }}
            />
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">
              Compartilhe com o time
            </h2>
            <p className="text-sm text-slate-200">
              Use o link{' '}
              <code className="text-xs break-all text-amber-200">
                https://leanit101.com/inside-sales
              </code>{' '}
              para validar com comercial e liderança.
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Objetivo</h2>
            <p className="text-sm text-slate-200">
              Confirmar se o agente conduz a conversa até diagnóstico e convite
              para reunião de forma natural.
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Rastreio</h2>
            <p className="text-sm text-slate-200">
              Eventos chegam com organizationId 31 e metadados Inside Sales.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InsideSalesPage
